module.exports = __webpack_public_path__ + "static/img/6.85d7607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v14_new_features/6.png
// module id = ZyzV
// module chunks = 0